module.exports = __webpack_public_path__ + "static/media/shape_2.367591ce.png";